import { render, staticRenderFns } from "./LgFinderPageGrupo.vue?vue&type=template&id=074f0f90"
import script from "./LgFinderPageGrupo.vue?vue&type=script&lang=js"
export * from "./LgFinderPageGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports